import { FormControl } from '@angular/forms';
import { IFormBuilder } from '../IFormBuilder';
import { GenericBaryFormGroup, IGenericBaryFormGroup } from '../GenericBaryFormGroup';
import { BaryFormFactoryService } from '../../../services/bary-form-factory.service';

interface ILoginFormBuilder extends IFormBuilder<LoginControls> {
  init(): ILoginFormBuilder;

  build(): IGenericBaryFormGroup<LoginControls>;
}

export type LoginControls = {
  email: FormControl;
  password: FormControl;
  rememberMe: FormControl;
};

export class LoginFormBuilder implements ILoginFormBuilder {
  private formName = 'loginForm';
  private controls?: LoginControls;

  constructor(private bcf: BaryFormFactoryService) {}

  init(): LoginFormBuilder {
    this.controls = this.bcf.makeLoginControls();
    return this;
  }

  build(): IGenericBaryFormGroup<LoginControls> {
    return new GenericBaryFormGroup<LoginControls>(this.formName, this.controls!);
  }
}
